import React, { useEffect, useState } from "react";
import "./Bill.css";
import { useUser } from "src/business-types/grocery/components/UserContext";
import Image from "../Image";

interface LogoProps {
  username?: string;
}

function Logo({ username }: LogoProps) {
  const [logo, setLogo] = useState<string>("");
  const [logoError, setLogoError] = useState(false);
  const [userInitial, setUserInitial] = useState<string>("U");
  const [backgroundColor, setBackgroundColor] = useState<string>("#3b82f6");
  const { user } = useUser();

  useEffect(() => {
    // console.log("Loading images, Username:", username);
    const busname = sessionStorage.getItem("organization_name");
    const imgs = sessionStorage.getItem(`Logo${busname}`);
    if (imgs) {
      setLogo(imgs);
      setLogoError(false);
    }
    initializeUserAvatar();
  }, [username]);

  const initializeUserAvatar = () => {
    const initial = getUserInitial();
    const bgColor = getAvatarBackgroundColor();
    setUserInitial(initial);
    setBackgroundColor(bgColor);
  };

  const getUserInitial = () => {
    if (username && username.length > 0) {
      // console.log("Using prop username:", username);
      return username.charAt(0).toUpperCase();
    }

    const sessionProfileName = sessionStorage.getItem("Profilename");
    if (sessionProfileName && sessionProfileName.length > 0) {
      // console.log("Using sessionStorage Profilename:", sessionProfileName);
      return sessionProfileName.charAt(0).toUpperCase();
    }

    const sessionUsername = sessionStorage.getItem("username");
    if (sessionUsername && sessionUsername.length > 0) {
      // console.log("Using sessionStorage username:", sessionUsername);
      return sessionUsername.charAt(0).toUpperCase();
    }

    // console.log("No username found, using default 'U'");
    return "U";
  };

  const getAvatarBackgroundColor = () => {
    let userToColor = "";

    if (username && username.length > 0) {
      userToColor = username;
    } else {
      userToColor = sessionStorage.getItem("Profilename") || sessionStorage.getItem("username") || "";
    }

    if (!userToColor) return "#3b82f6";

    const colors = [
      "#3b82f6",
      "#ef4444",
      "#10b981",
      "#f59e0b",
      "#8b5cf6",
      "#ec4899",
      "#06b6d4",
      "#84cc16",
      "#f97316",
      "#6366f1",
      "#14b8a6",
      "#84cc16",
    ];

    let hash = 0;
    for (let i = 0; i < userToColor.length; i++) {
      hash = userToColor.charCodeAt(i) + ((hash << 5) - hash);
    }
    hash = Math.abs(hash);

    return colors[hash % colors.length];
  };

  if (user?.profile_image_url) {
    return <Image imagePath={user?.profile_image_url} company={true} className='logo-container' />;
  }

  return (
    <div
      className={`w-10 h-10 rounded-full flex items-center justify-center text-white font-bold text-base font-sans`}
      style={{ backgroundColor: backgroundColor }}
    >
      {userInitial}
    </div>
  );
}

export default Logo;
